import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { patchJson } from '@/utils/fetchOptions';

// eslint-disable-next-line import/no-cycle
import { useAuthToken, useMutation } from '.';

export type TeamMemberBrandSettingsUpdateVars = {
  userId: string;
  brandId: string;
  want_email_notifications?: boolean;
  show_campaigns?: boolean;
};

interface UseTeamMemberBrandSettingsUpdateProps {
  onSuccess: TypeAny;
  teamId: string;
}

export function useTeamMemberBrandSettingsUpdate({
  onSuccess,
  teamId
}: UseTeamMemberBrandSettingsUpdateProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    mutate: mutation,
    error,
    isLoading
  } = useMutation({
    mutationKey: 'team-member-brand-settings-update',
    queryData: teamId,
    mutationFn: async (vars: TeamMemberBrandSettingsUpdateVars) => {
      const body: {
        want_email_notifications?: boolean;
        show_campaigns?: boolean;
      } = {};
      if (vars.want_email_notifications !== undefined) {
        body.want_email_notifications = vars.want_email_notifications;
      }
      if (vars.show_campaigns !== undefined) {
        body.show_campaigns = vars.show_campaigns;
      }
      return patchJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/member/${vars.userId}/brand/${vars.brandId}/update`,
        body,
        token
      }).then((response: Api.Member | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      });
    },
    onSuccess
  });

  return {
    isLoading,
    mutation,
    error
  };
}
